export { default as SalesRoutes } from './SalesRoutes';
